import * as React from 'react';

import { PictureProfile } from '../../../../../ResizedImage/PictureProfile.csharp';
import { IsFromPriceSpiderAccessor } from '../../../../Purchase/IsFromPriceSpiderAccessor';
import { GoogleTagManager } from '../../../../Tracking/GoogleTagManager/GoogleTagManager';
import { OrderSummaryDisplayMode } from '../../ViewModels/OrderSummaryDisplayMode.csharp';
import { OrderViewModel } from '../../ViewModels/OrderViewModel.csharp';
import { collectReviews } from '../ServiceReviews/CollectReviews';
import { ServiceReviewsViewModel } from '../ServiceReviews/ViewModel/ServiceReviewsViewModel.csharp';
import { OrderDetailsNotShippablePackage } from './OrderDetailsNotShippablePackage';
import { OrderDetailsPackage } from './OrderDetailsPackage';
import { OrderDetailsPriceSummary } from './OrderDetailsPriceSummary';
import { OrderDetailsSummary } from './OrderDetailsSummary';

interface OrderDetailsContentProps {
    order: OrderViewModel;
    itemPictureProfile: PictureProfile;
    serviceReviews: ServiceReviewsViewModel;
    favouritesUrl: string;
    invoices: string[];
    invoiceAvailabilityUrl: string;
    invoiceDownloadUrl: string;
    showInvoices: boolean;
}

export default class OrderDetailsContent extends React.Component<OrderDetailsContentProps> {
    componentDidMount() {
        const {
            order: { packages, paymentType, total, shippingCost, shippingName, discountCode, number, trackingId },
            serviceReviews
        } = this.props;

        const items = packages.flatMap((p) => p.items);
        const itemsFromPriceSpider = items.filter((i) => i.isFromPriceSpider);

        if (this.isRedirectedFromCheckout()) {
            GoogleTagManager.purchase(
                items,
                {
                    id: number,
                    revenue: total,
                    shipping: shippingCost,
                    coupon: discountCode,
                    shippingMethod: shippingName,
                    paymentMethod: paymentType
                },
                trackingId
            );
            if (itemsFromPriceSpider.length > 0) {
                GoogleTagManager.priceSpiderPurchase(itemsFromPriceSpider);
                IsFromPriceSpiderAccessor.clear();
            }

            this.clearRedirectionFlag();
            collectReviews(serviceReviews);
        }
    }

    isRedirectedFromCheckout = () => {
        const params = new URLSearchParams(window.location.search);
        const redirected = params.get('redirected');
        return redirected === 'true';
    };

    clearRedirectionFlag = () => {
        const params = new URLSearchParams(window.location.search);
        params.delete('redirected');
        let url = window.location.pathname;
        const remainingParams = params.toString();
        if (remainingParams) {
            url += '?' + remainingParams;
        }

        window.history.replaceState(null, '', url);
    };

    render() {
        const { order, itemPictureProfile, invoices, invoiceAvailabilityUrl, invoiceDownloadUrl, showInvoices } = this.props;

        return (
            <div className="OrderDetails__Inner">
                <OrderDetailsSummary
                    id={order.number}
                    status={order.status}
                    deliveryDate={order.requestedDeliveryDate}
                    createdDate={order.created}
                    paymentType={order.paymentType}
                    invoices={invoices}
                    invoiceAvailabilityUrl={invoiceAvailabilityUrl}
                    invoiceDownloadUrl={invoiceDownloadUrl}
                    showInvoices={showInvoices}
                />

                <div>
                    {order.packages.map((p, i) => {
                        return (
                            <OrderDetailsPackage
                                key={i}
                                packageNumber={i + 1}
                                trackingUrl={p.trackingUrl}
                                isSent={p.isSent}
                                totalPackagesAmount={order.packages.length}
                                shippingDisplayName={order.shippingDisplayName}
                                address={order.shippingAddress}
                                items={p.items}
                                pictureProfile={itemPictureProfile}
                                isPackageInfoAvailable={order.summaryDisplayMode == OrderSummaryDisplayMode.Full}
                                rxLoginBaseUrl={p.items.some((x) => x.isRx) ? order.rxLoginBaseUrl : undefined}
                                favouritesUrl={this.props.favouritesUrl}
                            />
                        );
                    })}

                    {order.notShippableItems?.length > 0 && (
                        <OrderDetailsNotShippablePackage items={order.notShippableItems} pictureProfile={itemPictureProfile} />
                    )}
                </div>
                {order.summaryDisplayMode != OrderSummaryDisplayMode.None && <OrderDetailsPriceSummary order={order} />}
            </div>
        );
    }
}
